import { TParsedContent } from "../model/types";

export function parseMessageContent(content: string): TParsedContent {
  try {
    const parsed = JSON.parse(content);
    if (parsed.type === "error") {
      return { type: "error", content: parsed.content || "An error occurred" };
    }
    return { type: "answer", content: parsed.content || content };
  } catch {
    return { type: "answer", content };
  }
}
